import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class BudgetItemAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BudgetItems';

  /**
   * Lấy dữ liệu mục theo mã tiểu mục
   * NXCHIEN 15.04.2022
   */
  getItemBySubItem(budgetSubItemCode) {
    let request = {
      url: [this.getAPIUrl(), `DataBudgetItem?budgetSubItemCode=${budgetSubItemCode}`].join('/'),
    };

    return httpClient.getAsync(request);
  }
}

export default new BudgetItemAPI();
